module.exports = __webpack_public_path__ + "static/media/iitlogo.5fdace20.png";